<template>
    <div class="profile-fields custom-fields">
        <div class="profile-field custom-field" v-if="profile.organization">
            <div v-if="profile.type == 'school'">School or District</div>
            <div v-if="profile.type == 'organization'">Organization</div>
            <div><h4>{{profile.organization}}</h4></div>
        </div>

        <div class="profile-field custom-field" v-if="profile.role">
            <div>Role</div>
            <div><h4>{{profile.role}}</h4></div>
        </div>

        <div class="profile-field custom-field" v-if="profile.grade_level && profile.type == 'school'">
            <div>Grade Level</div>
            <div><h4>{{profile.grade_level}}</h4></div>
        </div>

        <div class="profile-field custom-field" v-if="profile.subject && profile.type == 'school'">
            <div>Subject</div>
            <div><h4>{{profile.subject}}</h4></div>
        </div>
    </div>
</template>

<script>
export default {
  props: [
    'profile',
    'attributes'
  ],
  data() {
    return {

    };
  },
  components: {

  },
  methods: {

  }
};
</script>
